import React from "react"
import DeleteFilter from "../../../../../assets/iconos/close.svg";
import Helpers, { number_format } from "../../../../../config/Helpers";

class RevPar extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
            result_rows     : (<div></div>),
            total_widgets   : { 
                revenue_by_widget_ly : 0, 
                revenue_by_widget : 0, 
                revenue_budget_by_widget : 0,
                revenue_bb_by_widget : 0 
            }
        }
    }
    activeWdg(type){
        this.props.layout.activeWidget(type)
    }

    componentWillReceiveProps(props){
        const
            has_statics_channels  = (Object.keys(this.props.layout.state.statics_channels).length > 0),
            has_statics_segments  = (Object.keys(this.props.layout.state.statics_segments).length > 0),
            has_statics_time      = (Object.keys(this.props.layout.state.statics).length > 0);

        let wdg_aux = [];
        wdg_aux["channels"] = this.props.layout.state.statics_channels; 
        wdg_aux["segments"] = this.props.layout.state.statics_segments; 
        wdg_aux["trimester"] = this.props.layout.state.statics_trimester; 
        wdg_aux["months"] = this.props.layout.state.statics; 
        
        this.state.totals_general = (
            <div className={"datagrid-month totals"}>
                <div>${ number_format(this.state.total_widgets.revpar_by_widget_ly,2)}</div>
                <div>${ number_format(this.state.total_widgets.revpar_by_widget,2)}</div>
                <div>${ number_format(this.state.total_widgets.revpar_budget_by_widget, 2) }</div>
                <div>{ this.props.filter_by_pace === 0 ? number_format(this.state.total_widgets.revpar_bb_by_widget,2) : number_format(this.state.total_widgets.revpar_pace_widget,2) }%</div>
            </div>
        );

        if(Object.keys(wdg_aux).length > 0){
            let key_times = this.props.layout.state.segmentActive;
            let key_times_aux = this.props.app._LayoutReview.state.key_time;
            this.state.result_rows = Object.keys(this.props.layout.state.statics).map((filt, index) => {
                if(has_statics_channels){
                    if((wdg_aux["channels"][filt] !== undefined) && (key_times_aux[filt] !== undefined)){
                        const wdg = wdg_aux["channels"][filt];
                        return Object.keys(wdg).map((filt_aux, index_aux) => {
                            if(filt_aux !== "totals"){
                                //if(wdg[filt_aux].num_reservations !== 0){
                                    let channel_list = wdg[filt_aux];
                                    if(key_times[filt_aux] !== undefined){
                                        return Object.keys(channel_list).map((filt_channel, index_channel) => {
                                            return this.getRow(channel_list, filt_channel, index_aux)
                                        })
                                    }else{
                                        return this.getRow(wdg[filt_aux], "totals", index_aux, false)
                                    }
                                //}
                            }else{
                                return this.getRow(wdg, filt_aux, index_aux)
                            }
                        })
                    }
                }   
                if(has_statics_segments){
                    if((wdg_aux["segments"][filt]['segments'] !== undefined) && (key_times_aux[filt] !== undefined)){
                        const wdg = wdg_aux["segments"][filt]["segments"];
                        return Object.keys(wdg).map((filt_aux, index_aux) => {
                            //if(wdg[filt_aux].num_reservations !== 0){
                                return this.getRow(wdg, filt_aux, index_aux)
                            //}
                        })
                    }
                }
                if(has_statics_time){
                    //if(wdg_aux["months"][filt].num_reservations !== 0){
                        return this.getRow(wdg_aux["months"], filt, index)
                    //}
                }
            })
        }
        this.setState({ total_widgets : this.props.layout.state.total_widgets });
    }
    getRow(wdg_aux, filt, index, title = true){
        return filt !== "totals" ? 
            <div key={"list-room-night-"+index} className={ index%2 ? "row-c" : "" }>
                <div>${ number_format(wdg_aux[filt].revpar_ly,2) }</div>
                <div>${ number_format(wdg_aux[filt].revpar,2) }</div>
                <div>${ number_format(wdg_aux[filt].revpar_budget,2) }</div>
                <div>{ this.props.filter_by_pace === 0 ? number_format(wdg_aux[filt].revpar_vs_budget,2) : number_format(wdg_aux[filt].revpar_pace,2) }%</div>

            </div>
        : <div className={"datagrid-month " + (title === true ? "totals" : (index%2 ? "row-c" : ""))}>
            <div>${number_format(wdg_aux[filt].revpar_by_widget_ly,2)}</div>
            <div>${number_format(wdg_aux[filt].revpar_by_widget,2)}</div>
            <div>${ number_format(wdg_aux[filt].revpar_budget_by_widget,2) }</div>
            <div>{ this.props.filter_by_pace === 0 ? number_format(wdg_aux[filt].revpar_bb_by_widget,2) : number_format(wdg_aux[filt].revpar_pace_widget,2) }%</div>

        </div>
    }

    render(){
        
        return (
            <div className={"datagrid-widget revpar " + this.props.layout.state.hidden_wdg_revpar}>
                <div className="container-fluid">
                    <div className="row header-widget">
                        <div className="col-md-12 options-widget">
                            <span className="title">REVPAR</span>
                            
                            <span className="opt remove-widget" onClick={this.activeWdg.bind(this, "revpar")}>
                                <img src={DeleteFilter} />
                            </span>
                        </div>
                    </div>
                    <div className="current-values">
                        <div className="row">
                            <div className="col-md-12 head-current">
                                <span>{this.props.app.state.past_year}</span>
                                <span>{this.props.app.state.current_year}</span>
                                <span>BUDGET</span>
                                <span>BOOK vs.<br /> {this.props.filter_by_pace === 0 ? "BUDGET" : this.props.app.state.past_year}</span>

                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 datagrid-list">
                                { this.state.result_rows }
                                { this.state.totals_general }
                            </div>
                        </div>
                    </div>   
                </div>
            </div>
        )
    }
}

export default RevPar



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/review/views/Review/RevPar.js